import React, {useEffect} from "react";
import {RectBtn} from "../components/General";
import {useNavigate} from "react-router-dom";

const NotFound = ({setDisplayNavBar}) => {
  useEffect(() => {
    setDisplayNavBar(false);
  }, []);
  const navigate = useNavigate();
  return (
    <div className="not-found">
      <h1> 404 NOT FOUND </h1>
      <p className="not-found-hint">
        Oops... The page you were looking for is not found. Please check if you
        type in the link correctly.
      </p>
      <div className="back-to-dashboard">
        <RectBtn
          onClick={() => {
            setDisplayNavBar(true);
            navigate("/dashboard");
          }}
        >
          Dashboard
        </RectBtn>
      </div>
    </div>
  );
};

export default NotFound;
